import { get } from "@utils/axios_api";

export const validateDuplicateId = async (value) => {
  try {
    const response = await get(`/common/validateDuplicateId?id=${value}`);
    return response.result ? "이미 사용 중인 아이디 입니다." : true;

  } catch (error) {
    return "아이디 검증 중 오류가 발생했습니다.";
  }
};

export const validateDuplicateEmail = async (value) => {
  try {
    const response = await get(`/common/validateDuplicateEmail?email=${value}`);
    return response.result ? "이미 사용 중인 이메일 입니다." : true;
  } catch (error) {
    return "이메일 검증 중 오류가 발생했습니다.";
  }
};

export const validateDuplicateBizRegNo = async (value) => {
  try {
    const response = await get(`/common/validateDuplicateBizRegNo?bizRegNo=${value}`);
    return response.result ? "이미 등록된 사업자번호 입니다." : true;
  } catch (error) {
    return "사업자번호 검증 중 오류가 발생했습니다.";
  }
};
